<template>
    <v-container fluid>
        <div class="modal-padding cp3-modal fix-error-message">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down top-margin-10">
                        <div class="label-data edit-student-label">Edit Student:</div>
                        <div class="field-data">
                            <v-text-field v-model="name" class="fix-200" ></v-text-field>
                            <InputError :data='error.name' />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">
                            Select Center:
                        </div>
                        <div class="field-data">
                            <v-select v-model="selectedCenterId" @change="onManuallyChangeCenter" :items="centers" dense hide-details class="fix-200" filled></v-select>
                            <InputError :data='error.center' />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">
                            Select Batch:
                        </div>
                        <div class="field-data">
                            <v-select  v-model="selectedBatch" :items="batches" hide-details dense class="fix-200" filled></v-select>
    
                            <InputError :data='error.batch' />
                        </div>
                    </div>
                </v-col>
                <v-col v-if="onlineUser" cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">
                            Select Target Exam:
                        </div>
                        <div class="field-data">
                            <v-select v-model="selectedTargetExam" :items="examList" hide-details dense class="fix-200" filled></v-select>
    
                            <InputError :data='error.class' />
                        </div>
                    </div>
                </v-col>
                <v-col v-if="onlineUser" cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">
                            Select Target Year:
                        </div>
                        <div class="field-data">
                            <v-select v-model="selectedTargetYear" :items="classes" hide-details dense class="fix-200" filled></v-select>
    
                            <InputError :data='error.class' />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">
                            Roll Number:
                        </div>
                        <div class="field-data">
                            <v-text-field v-model="rollNumber" min="1" :disabled="data&&data.is_approved&&data.roll_number?true:false" type="number" @keydown.space.prevent @keypress="allowedOnlyNumber($event, true)" class="fix-200" ></v-text-field>
    
                            <InputError :data='error.roll_number' />
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="bottom-btn">
                        <v-btn :loading="approvalLoading" @click="onSaveOrApprove(true)" class="right-btn cust-btn" color="primary">Approve</v-btn>
                        <v-btn :loading="saveLoading" @click="onSaveOrApprove(false)" class="right-btn cust-btn" color="primary">Save & return</v-btn>
                        <v-btn @click="onClose({status:false})" class="right-btn cust-btn" color="primary">Cancel</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: 'EditStudentBatchDetails',
    props: ['onClose', 'data', 'status'],
    data() {
        return {
            name: this.data ? this.data.name : '',
            approvalLoading: false,
            saveLoading: false,
            batches: [],
            centers: [],
            classes: [],
            selectedCenterId: this.data ? this.data.center_id : null,
            selectedBatch: this.data ? this.data.batch_id : null,
            selectedTargetYear: this.data && this.data.class_code ? this.data.class_code.includes('##') ? Number(this.data.class_code.split('##')[1]) : Number(this.data.class_code) : null,
            error: {
                name: {
                    type: null,
                    message: 'Please enter name'
                },
                batch: {
                    type: null,
                    message: 'Please select batch'
                },
                center: {
                    type: null,
                    message: 'Please select center',
                },
                class: {
                    type: null,
                        message: 'Please select target year'
                },

                roll_number: {
                    type: null,
                        message: "Roll number must be a maximum of 10 digits."
                }
            },
            rollNumber: this.data && this.data.roll_number ? this.data.roll_number: null,
            onlineUser: false,
            selectedTargetExam: this.data && this.data.class_code ? this.data.class_code.includes('##') ? this.data.class_code.split('##')[0] : this.data.class_code : null,
            examList: constants.TARGET_EXAM.map((c) => c),
        }
    },
    methods: {
        ...mapActions({
            getClasses: "userStore/getClasses",
            getCenters: "centerAndBatchStore/getCenters",
            getBatches: "centerAndBatchStore/getBatches",
            approveOrSaveStudent: "userStore/approveOrSaveStudent"

        }),
        onSaveOrApprove(requireApproval) {
            if (this.validate()) {
                let centerName = this.centers.find((x) => x.value === this.selectedCenterId);
                let reqData = {
                    role_id: this.roleIds.ST,
                    status: 1,
                    user_ids: [this.data.id],
                    batch_id: this.selectedBatch,
                    class_code: this.selectedTargetYear ? (this.selectedTargetYear).toString() : centerName.text ,
                    require_approval: requireApproval,
                    name: this.name,
                    target_exam: this.selectedTargetExam,
                    target_year: (this.selectedTargetYear).toString(),
                    roll_number: this.rollNumber
                }

                this.approvalLoading = requireApproval;
                this.saveLoading = !requireApproval;
                this.approveOrSaveStudent(reqData).then(response => {
                        this.approvalLoading = false;
                        this.saveLoading = false;
                        this.$toasted.success(`Success\n${response.message}`, { icon: 'check_circle' });
                        this.onClose({ status: false, reload: true })
                    })
                    .catch(err => {
                        this.approvalLoading = false;
                        this.saveLoading = false;
                    });


            }
        },

        validate() {
            let isValid = true;
            this.error.center.type = null;
            this.error.batch.type = null;
            this.error.class.type = null;
            this.error.name.type = null;
            if ((!this.name || this.name.length < 1)) {
                this.error.name.type = 'error';
                isValid = false;
            }
            if ((!this.selectedCenterId)) {
                this.error.center.type = 'error';
                isValid = false;
            }
            if ((!this.selectedBatch)) {
                this.error.batch.type = 'error';
                isValid = false;
            }
             if ((!this.selectedTargetYear) && this.onlineUser) {
                this.error.class.type = 'error';
                isValid = false;
            }

            if ((this.rollNumber) && this.rollNumber.length > 10) {
                this.error.roll_number.type = 'error';
                isValid = false;
            }
            return isValid;
        },
        requestGetClasses() {
            this.$root.showLoader = true;
            this.getClasses().then(response => {
                    this.$root.showLoader = false;
                    this.classes = response
                        .map(x => {
                            let c = {};
                            c.text = x.name;
                            c.value = x.class_code;
                            return c;

                        })

                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        onManuallyChangeCenter(centerId) {
            this.selectedBatch = null;
            this.onCenterSelect(centerId)
        },
        onCenterSelect(centerId) {

            this.batches = [];
            this.$root.showLoader = true;
            this.getBatches({ center_id: [centerId] }).then(response => {
                    this.$root.showLoader = false;
                    this.batches = response.list
                        .map(x => {
                            let c = {};
                            c.text = x.name;
                            c.value = x.id;
                            return c;

                        })

                })
                .catch(err => {
                    this.$root.showLoader = false;
                });

        },
        requestGetCenters() {
            this.$root.showLoader = true;
            this.getCenters().then(response => {
                    this.$root.showLoader = false;
                    this.centers = response
                        .map(x => {
                            let c = {};
                            c.text = x.name;
                            c.value = x.id;
                            return c;

                        })

                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
    },
    mounted() {
        this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? false : true        
        if (this.data && this.data.center_id) {
            this.onCenterSelect(this.data.center_id);
        }
        this.requestGetCenters();
        this.requestGetClasses();

    },
    computed: {
    ...mapState("userStore", ["user"]),
    },
    watch: {
        status(val) {
            this.selectedCenterId = this.data ? this.data.center_id : null;
            this.selectedBatch = this.data ? this.data.batch_id : null;
            this.selectedTargetYear = this.data && this.data.class_code ? this.data.class_code.includes('##') ? Number(this.data.class_code.split('##')[1]) : Number(this.data.class_code) : null;
            this.name = this.data ? this.data.name : null;
            if (val) {
                if (this.data && this.data.center_id) {
                    this.onCenterSelect(this.data.center_id);
                }
            }
            this.rollNumber = this.data && this.data.roll_number ? this.data.roll_number: null;
            this.selectedTargetExam = this.data && this.data.class_code ? this.data.class_code.includes('##') ? this.data.class_code.split('##')[0] : this.data.class_code : null
        },
        selectedCenterId(val) {
            this.error.center.type = null;
        },
        selectedTargetYear(val) {
            this.error.class.type = null;
        },
        selectedBatch(val) {
            this.error.batch.type = null;
        },
        name() {
            this.error.name.type = null;
        },
        selectedTargetExam() {
            this.error.class.type = null
        },

        rollNumber() {
            this.error.roll_number.type = null;
        }
    }
}
</script>